module.exports = __webpack_public_path__ + "static/media/butcher-boy.bf389dc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/butcher-boy.jpg
// module id = 1637
// module chunks = 0